import React from "react";
import { useNavigate } from "react-router-dom";
import AppHeader from "@/components/drill/AppHeader";
import { useFeaturePermissions } from "@/lib/FeaturePermissionContext";
import { Button } from "@/components/ui/button";
import { Beaker, Droplets } from "lucide-react";

const TOOLS = [
  { label: "Viscosity check", icon: Beaker, path: "/tools/viscosity-check" },
  { label: "Flow Rate", icon: Droplets, path: "/tools/flow-rate" },
];

export default function Tools() {
  const navigate = useNavigate();
  const { canUseFeature } = useFeaturePermissions();

  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-50 to-slate-100 dark:from-slate-950 dark:to-slate-900">
      <AppHeader title="Tools" subtitle="Drilling field tools" backTo="/" />

      <main className="max-w-7xl mx-auto px-4 sm:px-6 py-8 pb-24">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {TOOLS.filter(({ path }) => path === "/tools/viscosity-check" ? canUseFeature("viscosity_check") : canUseFeature("flow_rate")).map(({ label, icon: Icon, path }) => (
            <Button
              key={label}
              onClick={() => navigate(path)}
              variant="outline"
              className="h-24 rounded-2xl text-base font-semibold gap-3 justify-start px-6 bg-transparent"
            >
              <Icon className="w-6 h-6" />
              {label}
            </Button>
          ))}
        </div>
      </main>
    </div>
  );
}